export default "/images/vendor/flag-icon-css/flags/1x1/um.svg?d0a77d97960f20600dc6922439f1faae";